import { RootState } from '../..';

export const selectors = {
	init: {
		get: (state: RootState) => state.schedule.init
	},
	actions: {
		get: (state: RootState) => state.schedule.actions,
		getData: (state: RootState) => state.schedule.actions.data,
		getLoaded: (state: RootState) => state.schedule.actions.loaded,
		getPage: (state: RootState) => state.schedule.actions.page,
		getQuery: (state: RootState) => state.schedule.actions.query
	},
	selectedActions: {
		get: (state: RootState) => state.schedule.selectedActions
	},
	triggerState: {
		get: (state: RootState) => state.schedule.triggerState
	},
	tracker: {
		get: (state: RootState) => state.schedule.tracker,
		getActions: (state: RootState) => state.schedule.tracker.actions,
		getOpen: (state: RootState) => state.schedule.tracker.open,
		getSelected: (state: RootState) => state.schedule.tracker.selected
	}
};
